import styled from 'styled-components'

import { fonts } from '../styles/branding'

export const Passage = styled.div`
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: ${(props) => (props.isPreSubway ? '48px 0' : '24px 0')};
  margin: ${(props) => (props.isPreSubway ? '0 40px' : ' 0 48px')};
  border-bottom: ${({ light }) => `2px solid ${light ? '#e6e6e6' : '#808080'}`};
  &:last-child {
    border-bottom: none !important;
  }
  @media (max-width: 600px) {
    padding: 12px 0;
    margin: 0 12px;
  }
`
export const LineContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  @media (max-width: 600px) {
    min-width: 35px;
    svg {
      width: 32px;
      height: 34px;
    }
  }
`
export const Vignette = styled.div`
  position: relative;
  display: flex;
  align-self: center;
  width: ${(props) => (props.isPreSubway ? '96px' : '60px')};
  height: ${(props) => (props.isPreSubway ? '72px' : '45px')};
  line-height: 1;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${(props) => props.backgroundColor};
  border: ${(props) => `5px solid ${props.backgroundBorder}`};
  color: ${(props) => props.color};
  & span {
    font-size: ${(props) => (props.isPreSubway ? '52px' : '32.5px')};
  }
  @media (max-width: 600px) {
    margin: 0 0 0 15px;
    border-radius: 6px;

    min-width: 40px;
    & span {
      font-size: 16px;
    }
  }
`
export const StopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${(props) => (props.isPreSubway ? '40px' : '24px')};
  @media (max-width: 600px) {
    padding-left: 12px;
  }
`
export const StopParagraph = styled.p`
  @media (max-width: 600px) {
    font-size: 15px;
  }
  margin: 0;
  font-family: ${fonts.fontFamilyBase};
  font-size: ${(props) => (props.isPreSubway ? '40px' : '36px')};
  font-weight: bold;
  line-height: 1;
  color: ${(props) => props.color};
  margin-bottom: 16px;
`
export const EndStopParagraph = styled.p`
  @media (max-width: 600px) {
    font-size: 12px;
  }
  margin: 0;
  font-family: ${fonts.fontFamilyBase};
  font-size: ${(props) => (props.isPreSubway ? '36px' : '24px')};
  line-height: 1.5;
  color: ${(props) => props.color};
`

export const DepartureContainer = styled.div`
  @media (max-width: 600px) {
    position: relative;
    svg {
      font-size: 1rem;
    }
    margin-right: ${(props) => (props.realtime ? '0' : '12px')};
  }
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: ${(props) => (props.isDeleted ? 'stretch' : 'flex-start')};
`

export const TimeSpan = styled.span`
  @media (max-width: 600px) {
    font-size: 16px;
    margin-left: 4px;
  }
  font-family: ${fonts.fontFamilyBase};
  font-size: ${(props) => (props.isPreSubway ? '48px' : '36px')};
  font-weight: bold;
  line-height: 1.25;
  color: ${(props) => props.color};
  .minute {
    font-size: ${(props) => (props.isPreSubway ? '36px' : '24px')};
  }
`
export const RealtimeWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  svg {
    position: absolute;
    right: -20px;
  }
  margin-bottom: ${(props) => (props.isPreSubway ? '32px' : '8px')};
  position: relative;
`
export const TheoreticalAndDelayWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const NoRealtimeWrapper = styled.div`
  font-family: ${fonts.fontFamilyBase};
  font-size: ${(props) => (props.isPreSubway ? '32px' : '24px')};
  line-height: 1;
  color: ${(props) => props.color};
  font-weight: bold;
  position: relative;
  svg {
    position: absolute;
    right: -20px;
    top: ${(props) => (props.isPreSubway ? '40px' : null)};
  }
  margin-bottom: ${(props) => (props.isPreSubway ? '32px' : '8px')};
`
export const TheoreticalTime = styled.span`
  font-family: ${fonts.fontFamilyBase};
  font-size: ${(props) => (props.isPreSubway ? '40px' : '24px')};
  line-height: 1;
  color: ${(props) => props.color};
  margin-right: 8px;
`
export const DeletedWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const DeletedTime = styled.span`
  font-family: ${fonts.fontFamilyBase};
  font-size: 24px;
  font-size: ${(props) => (props.isPreSubway ? '40px' : '24px')};
  line-height: 1;
  color: ${(props) => (props.lightMode ? '#EF3934' : '#F69B99')};
  text-decoration: line-through;
  font-weight: 700;
`

export const Delay = styled.span`
  color: ${(props) => props.color};
  font-family: ${fonts.fontFamilyBase};
  font-weight: bold;
  font-size: ${(props) => (props.isPreSubway ? '40px' : '24px')};
  line-height: 1;
  text-align: right;
  letter-spacing: -2px;
`

export const DeletedLabel = styled.span`
  @media (max-width: 600px) {
    padding: 6px 7px;
    font-size: 14px;
    border-radius: 4px;
  }
  display: inline-block;
  background-color: ${(props) =>
    props.isOnlyShortened ? '#ffe2b2' : '#F9C0BF'};
  border-radius: 4px;
  color: ${(props) => (props.isDeleted ? '#bb0022' : '#66380f')};
  font-size: ${(props) => (props.isPreSubway ? '36px' : '24px')};
  line-height: 1;
  font-weight: bold;
  padding: 12px 16px;
  margin-bottom: ${(props) => (props.isPreSubway ? '32px' : '16px')};
`

export const DangerIconWrapper = styled.div`
  && {
    position: absolute;
    bottom: ${(props) => (props.isPreSubway ? '-20px' : '-15px')};
    right: ${(props) => (props.isPreSubway ? '-25px' : '-17px')};

    @media (max-width: 600px) {
      width: 16px;
      height: 16px;
    }
  }
`

export const StatusLabel = styled.span`
  background: ${(props) => (props.lightMode ? '#E6E5E6' : '#666666')};
  border-radius: 4px;
  font-family: ${fonts.fontFamilyBase};
  font-weight: bold;
  font-size: ${(props) => (props.isPreSubway ? '36px' : '24px')};
  line-height: 1;
  color: ${(props) => (props.lightMode ? '#4D4D4D' : '#fafafa')};
  padding: 12px 16px;
  margin: 0 16px;
  align-self: flex-start;
`

export const TheoreticalTimeWrapper = styled.div`
  text-align: right;
`
